import * as React from "react"
import Avatar from "@mui/material/Avatar"
import Button from "@mui/material/Button"
import CssBaseline from "@mui/material/CssBaseline"
import TextField from "@mui/material/TextField"
import Paper from "@mui/material/Paper"
import Box from "@mui/material/Box"
import Grid from "@mui/material/Grid"
import LockOutlinedIcon from "@mui/icons-material/LockOutlined"
import Typography from "@mui/material/Typography"
import { createTheme, ThemeProvider } from "@mui/material/styles"
import Collapse from "@mui/material/Collapse"
import Alert from "@mui/material/Alert"

import { useAuthContext } from "../hooks/useAuthContext"
import { useNavigate } from "react-router-dom"

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      Zotech Technology Co., Ltd.
      {new Date().getFullYear()}
      {"."}
    </Typography>
  )
}

const theme = createTheme()

export default function SignInSide() {
  const [isError, setError] = React.useState(false)
  const [errMsg, setErrMsg] = React.useState("")

  const { dispatch } = useAuthContext()
  let navigate = useNavigate()

  const handleSubmit = async (event) => {
    event.preventDefault()

    const data = new FormData(event.currentTarget)

    const res = await fetch("/api/v2/users/login", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: data.get("email"),
        password: data.get("password"),
      }),
    })

    const json = await res.json()

    if (res.ok) {
      setError(false)
      localStorage.setItem("user", JSON.stringify(json))

      // update the auth context
      dispatch({ type: "LOGIN", payload: json })

      // navigate to home page
      navigate("/")
    } else {
      setError(true)
      setErrMsg(json.error)
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <Grid container component="main" sx={{ height: "100vh" }}>
        <CssBaseline />
        <Grid
          size={{ xs: 0, sm: 4, md: 8, xl: 9 }}
          sx={{
            backgroundImage: 'url("/images/bg-01.jpg")',
            backgroundRepeat: "no-repeat",
            backgroundColor: (t) =>
              t.palette.mode === "light"
                ? t.palette.grey[50]
                : t.palette.grey[900],
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <Grid
          size={{ xs: 12, sm: 8, md: 4, xl: 3 }}
          component={Paper}
          elevation={6}
          square
        >
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: "#aacd03" }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Sign in
            </Typography>
            <Box
              component="form"
              noValidate
              onSubmit={handleSubmit}
              sx={{ mt: 1 }}
            >
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
                onChange={() => setError(false)}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
                onChange={() => setError(false)}
              />
              <Collapse in={isError}>
                <Alert severity="error">{errMsg}</Alert>
              </Collapse>
              <Button
                type="submit"
                fullWidth
                variant="contained"
                disabled={isError}
                sx={{ mt: 3, mb: 2, borderRadius: 4, bgcolor: "#aacd03" }}
              >
                Sign In
              </Button>
              <Copyright sx={{ mt: 5 }} />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  )
}
